import { TComplimentaryProductInfo } from 'pages/dimensions/store/dimensions';
import { formatPrice } from 'common/helpers/format-amount';

export const getVariantText = (variant: TComplimentaryProductInfo): string => {
  const { salesPriceValueInConsumerUnitValue, total } = variant;
  const fullOptionPrice = salesPriceValueInConsumerUnitValue
    ? formatPrice(
        Number.parseFloat((salesPriceValueInConsumerUnitValue * total.requiredQuantity).toFixed(2))
      )
    : 0;
  const hasOnePieceData = Boolean(total.onePiece);

  return hasOnePieceData
    ? `${total.requiredQuantity} шт. x ${total.onePiece} = ${fullOptionPrice} ₽`
    : `${total.requiredQuantity} шт. = ${fullOptionPrice} ₽`;
};
